"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enUSLocaleText = exports.enUS = exports.DEFAULT_LOCALE = void 0;
var _getChartsLocalization = require("./utils/getChartsLocalization");
// This object is not Partial<ChartsLocaleText> because it is the default values

const enUSLocaleText = exports.enUSLocaleText = {
  // Overlay
  loading: 'Loading data…',
  noData: 'No data to display',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out'
};
const DEFAULT_LOCALE = exports.DEFAULT_LOCALE = enUSLocaleText;
const enUS = exports.enUS = (0, _getChartsLocalization.getChartsLocalization)(enUSLocaleText);